<div class="blank-layout-container justify-content-center">
  <div class="position-relative row w-100 h-100">
    <div class="col-lg-7 col-xl-8 bg-gredient p-0">
      <div class="p-24 h-100">
        <div
          class="align-items-center justify-content-center img-height d-none d-lg-flex"
        >
        <img
        src="/assets/images/logos/dark-logo.png"
          alt="login"
          style="max-width: 500px"
        />
        </div>
      </div>
    </div>
    <div class="col-lg-5 col-xl-4 p-0">
      <div
        class="d-flex align-items-start align-items-lg-center justify-content-center h-100"
      >
        <div class="row justify-content-center w-100">
          <div class="col-lg-9 max-width-form margin-box">
            <h4 class="f-w-700 f-s-24 m-0">Bienvenido a INGE!</h4>
            <span class="f-s-14 d-block mat-body-1 m-t-8"
              >Portal de Garantias</span
            >

            <div class="row m-t-24">
              <div class="col-12">
                <button
                  mat-stroked-button
                  class="w-100"
                  (click)="loginGoogle()"
                >
                  <div class="d-flex align-items-center">
                    <img
                      src="/assets/images/logos/google-icon.svg"
                      alt="google"
                      width="20"
                      style="margin-right: 1rem"
                    />
                    Ingresa con Google
                  </div>
                </button>
              </div>
            </div>

            <div class="m-t-30 m-b-30 text-center">O ingresa con</div>

            <mat-card-content class="b-t-1">
              <mat-tab-group>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="d-flex align-items-center">
                      <mat-icon>
                        <i-tabler name="user" class="icon-20 m-r-8"></i-tabler>
                      </mat-icon>
                    </div>
                    Usuario
                  </ng-template>
                  <form
                    class="m-t-30"
                    [formGroup]="UserForm"
                    (ngSubmit)="submit()"
                  >
                    <mat-label
                      class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block"
                      >RUT</mat-label
                    >
                    <mat-form-field
                      appearance="outline"
                      class="w-100"
                      color="primary"
                    >
                      <input
                        matInput
                        formControlName="rutUser"
                        (blur)="inputRut($event, 'rutUser')"
                      />
                      <mat-hint
                        *ngIf="fc['rutUser'].touched && !validateRut || fc['rutUser']?.errors?.['incorrect'] "
                        class="error-msg m-b-16"
                      >
                        <div class="text-error">
                          <ng-container
                            *ngIf="fc['rutUser']?.errors?.['incorrect']"
                          >
                            Este rut no es compatible.
                          </ng-container>
                          <ng-container *ngIf="!validateRut">
                            El RUT no es de persona natural.
                          </ng-container>
                        </div>
                      </mat-hint>
                    </mat-form-field>

                    <!-- password -->
                    <mat-label
                      class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block"
                      >Contraseña</mat-label
                    >
                    <mat-form-field
                      appearance="outline"
                      class="w-100"
                      color="primary"
                    >
                      <input
                        autocomplete="new-password"
                        matInput
                        type="password"
                        formControlName="passwordUser"
                      />
                      <mat-hint
                        *ngIf="
                          fc['passwordUser'].touched && fc['passwordUser'].invalid
                        "
                        class="m-b-16 error-msg"
                      >
                        <div
                          class="text-error"
                          *ngIf="
                            fc['passwordUser'].errors &&
                            fc['passwordUser'].errors['required']
                          "
                        >
                          Contraseña Requerdia
                        </div>
                      </mat-hint>
                    </mat-form-field>

                    <div class="d-flex align-items-center m-b-12">
                      <a
                        [routerLink]="['/side-forgot-pwd']"
                        class="text-primary f-w-600 text-decoration-none m-l-auto f-s-14"
                        >Olvidaste la Contraseña ?</a
                      >
                    </div>

                    <!-- input -->

                    <mat-action-row>
                      <button
                        mat-flat-button
                        color="primary"
                        class="w-100"
                        [disabled]="!UserForm.valid"
                      >
                        Ingresar
                      </button>
                    </mat-action-row>
                  </form>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="d-flex align-items-center">
                      <mat-icon>
                        <i-tabler name="building" class="icon-20 m-r-8"></i-tabler>
                      </mat-icon>
                    </div>
                    Empresa SII
                  </ng-template>
                  <form
                    class="m-t-30"
                    [formGroup]="UserSiiForm"
                    (ngSubmit)="submit()"
                  >
                    <mat-label
                      class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block"
                      >RUT Empresa</mat-label
                    >
                    <mat-form-field
                      appearance="outline"
                      class="w-100"
                      color="primary"
                    >
                      <input
                        matInput
                        formControlName="rutEmpresa"
                        (blur)="inputRut($event, 'rutEmpresa')"
                      />
                      <mat-hint
                        *ngIf="f['rutEmpresa'].touched && !validateRut || f['rutEmpresa']?.errors?.['incorrect'] "
                        class="error-msg m-b-16"
                      >
                        <div class="text-error">
                          <ng-container
                            *ngIf="f['rutEmpresa']?.errors?.['incorrect']"
                          >
                            Este rut no es compatible.
                          </ng-container>
                          <ng-container *ngIf="!validateRut">
                            El RUT no es Empresa.
                          </ng-container>
                        </div>
                      </mat-hint>
                    </mat-form-field>

                    <!-- password -->
                    <mat-label
                      class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block"
                      >Contraseña SII</mat-label
                    >
                    <mat-form-field
                      appearance="outline"
                      class="w-100"
                      color="primary"
                    >
                      <input
                        autocomplete="new-password"
                        matInput
                        type="password"
                        formControlName="passwordSii"
                      />
                      <mat-hint
                        *ngIf="f['passwordSii'].touched && f['passwordSii'].invalid"
                        class="m-b-16 error-msg"
                      >
                        <div
                          class="text-error"
                          *ngIf="
                            f['passwordSii'].errors &&
                            f['passwordSii'].errors['required']
                          "
                        >
                          Contraseña Requerdia
                        </div>
                      </mat-hint>
                    </mat-form-field>

                    <div class="d-flex align-items-center m-b-12">
                      <a
                        [routerLink]="['/side-forgot-pwd']"
                        class="text-primary f-w-600 text-decoration-none m-l-auto f-s-14"
                        >Olvidaste la Contraseña ?</a
                      >
                    </div>

                    <!-- input -->

                    <mat-action-row>
                      <button
                        mat-flat-button
                        color="primary"
                        class="w-100"
                        [disabled]="!UserSiiForm.valid"
                      >
                        Ingresar
                      </button>
                    </mat-action-row>
                  </form>
                </mat-tab>
              </mat-tab-group>
            </mat-card-content>

            <span class="d-block f-w-500 d-block m-t-24"
              >No tienes cuenta aun?
              <a
                [routerLink]="['/register']"
                class="text-decoration-none text-primary f-w-500 f-s-14"
              >
                Create una Cuenta</a
              >
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
